import React, { useEffect, useState } from 'react';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from "saur_ui_library/src/Atoms/Word/Word";
import Card from 'saur_ui_library/src/Molecules/Card/Card';
import { getInfoBulleMessage, resetImputLabel, resetOptions } from '../../../utils/helpers/module/filtersHelper';
import DataSelector from '../../common/component/dataSelector';
import Legend from '../../common/component/Legend';
import SingleFilter from '../component/SingleFilter';
import { avoidDuplicate } from '../../../utils/helpers/module/ecpHelper';
import { loaderDataComponent } from '../../../utils/helper';

const FiltersEcp = (props: any) => {
  // const for dropdownlist on change
  const [fonctionnement, setFonctionnement] = useState<any>(
    JSON.parse(window.sessionStorage.getItem('ecp_color')!) || ''
  );
  const [commune, setCommune] = useState<any>(
    JSON.parse(window.sessionStorage.getItem('ecp_commune')!) || {
      name: '',
      code: '',
      outField: 'InseeCode',
    }
  );
  const [bassinCollecte, setBassinCollecte] = useState<any>(
    JSON.parse(window.sessionStorage.getItem('ecp_bassinCollecte')!) || {
      name: '',
      code: '',
      outField: 'Code',
    }
  );
  // const for dropdownlists options
  const [communeOptions, setCommuneOptions] = useState<any>([]);
  const [bassinCollecteOptions, setBassinCollecteOptions] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const infoBulleMessageDataSelectorEcp = getInfoBulleMessage(props.module);

  // get communes options
  const getCommune = async () => {
    let communesData: any[] = props.allInseeCodesContract;
    if (communesData.length === 0) {
      resetImputLabel('ecp-filtre-commune');
    }
    let singleCommunesData = avoidDuplicate(communesData, 'name');
    setCommuneOptions(singleCommunesData);
  };

  // get installs options
  const getBassinCollecte = (pCommune: any) => {
    const res = pCommune !== '' ? props.allBc.filter((c: any) => c.commune === pCommune) : props.allBc;
    if (res.length === 0) {
      resetImputLabel('ecp-filtre-bassinCollecte');
    }
    let newBassinData: any[] = [];
    res.forEach((c: any) => {
      newBassinData.push({
        id: c.id,
        name: c.name,
        code: c.avalPoint !== null ? c.avalPoint : c.name,
        avalPoint: c.avalPoint,
        commune: c.commune,
        outField: 'Code',
      });
    });
    setBassinCollecteOptions(newBassinData);
    return newBassinData;
  };

  // component did mount
  useEffect(() => {
    setLoading(true);
    getCommune().then(() => {
      setLoading(false);
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // trigger dynamic dropdownlists hence on change (commune, type and deversement)
  useEffect(() => {
    if(loading === false){
      setLoading(true);
      getBassinCollecte(commune.name);
      setLoading(false);
    }
  }, [commune, fonctionnement]); // eslint-disable-line react-hooks/exhaustive-deps

  // we need to use this useEffect to update table 
  // when you open the module because this component is allready mounted
  // we need to wait for the end of the requests in ViewComponent
  useEffect(() => {
    // Re-populate commune dropdown when data arrives (handles race condition
    // where layers load before getCommunesForEcp resolves)
    setLoading(true);
    getCommune().then(() => {
      setLoading(false);
    });
    props.parentCallback({
      Color: fonctionnement,
      InseeCode: commune,
      Code: commune.name === '' ? bassinCollecte : {
        name: '',
        code: '',
        outField: 'Code',
      },
      CollectionPools: getBassinCollecte(commune.name),
    });
  }, [props.allInseeCodesContract]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Container className='filterForm'>
      <Card automatedTestId={props.module + '-filter'}>
        <Word
          value='FILTRER MA RECHERCHE'
          textStyle='title'
          variant='h1'
          automatedTestId='search-word'
        />
        <Legend type={localStorage.getItem('type')!} />
        <Container className='fonctionnement'>
          <Word
            value='Fonctionnement'
            textStyle='normalReg'
            variant='p'
            automatedTestId='id-fonctionnement'
          />
          <DataSelector
            infoBulles={infoBulleMessageDataSelectorEcp}
            sendSelectedColor={(d: any) => {
              setFonctionnement(d);
              window.sessionStorage.setItem('ecp_color', JSON.stringify(d));
              fonctionnement !== '' &&
                props.parentCallback({
                  Color: d,
                  InseeCode: commune,
                  Code: bassinCollecte,
                  CollectionPools: getBassinCollecte(commune.name),
                });
            }}
            type='ecp'
            sessionStorageName='ecp_color'
          />
        </Container>
        {commune !== null && (
          <SingleFilter
            module='ecp'
            title='Communes :'
            filterName='commune'
            filterOptions={communeOptions}
            parentCallback={(d) => {
              setCommune(d);
              resetOptions(
                d,
                'ecp-filtre-bassinCollecte',
                setBassinCollecteOptions
              );
              props.parentCallback({
                Color: fonctionnement,
                InseeCode: d,
                Code: {
                  name: '',
                  code: '',
                  outField: 'Code',
                },
                CollectionPools: getBassinCollecte(d.name),
              });
              window.sessionStorage.setItem('bassinecp', JSON.stringify({name: '', code: ''}));
            }}
            outField='InseeCode'
          />
        )}
        {bassinCollecte !== null && (
          <SingleFilter
            module='ecp'
            title='Bassin de collecte :'
            filterName='bassinCollecte'
            filterOptions={bassinCollecteOptions}
            parentCallback={(d) => {
              setBassinCollecte(d);
              props.parentCallback({
                Color: fonctionnement,
                InseeCode: commune,
                Code: d,
                CollectionPools: getBassinCollecte(commune.name),
              });
              // manage highlights
              if (d === null) {
                window.sessionStorage.setItem('bassinecp', JSON.stringify({name: '', code: ''}));
                window.sessionStorage.setItem('codesEcp', 'null');
              } else {
                window.sessionStorage.setItem('bassinecp', JSON.stringify(d));
              }
            }}
            outField='Code'
          />
        )}
        {loaderDataComponent(loading)}
      </Card>
    </Container>
  );
};;
export default FiltersEcp;
